<template>
  <div class="toggle-rating-con">
    <div class="align-items-center d-flex mandatory">
      <p class="mandatory">{{ field.name }}</p>
      <b-form-checkbox
        switch
        size="lg"
        :id="field.id"
        v-model="toggleButtonModel.value"
        @change="emitUpdate"
        class="switch-gray"
      ></b-form-checkbox>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  props: {
    field: {},
  },
  data() {
    return {
      toggleButtonModel: null,
    };
  },
  beforeMount() {
    this.toggleButtonModel = cloneDeep(this.field);
  },
  methods: {
    emitUpdate() {
      this.$emit("updateToggle", this.toggleButtonModel);
    },
  },
};
</script>
<style lang="scss">
.toggle-rating-con {
  .mandatory,
  .filled-by,
  .padge {
    width: 416px;
    border-radius: 4px;
    background: #f2f2f2;
    height: 55px;
    margin-bottom: 16px;
    padding-inline-end: 20px;
    padding-inline-start: 18px;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  p.mandatory,
  p.filled-by,
  p.padge {
    margin-bottom: 0 !important;
    color: var(--Grey-1, #787878);
    display: contents;
    font-size: 16px;
    font-weight: 700;
    line-height: normal;
  }
  .switch-gray .custom-control-label::before {
    top: 0 !important;
    width: 43px !important;
    height: 21px !important;
    background: #d1d1d1 !important;
    border: none !important;
    border-radius: 13.5px;
  }

  .switch-gray .custom-control-label::after,
  .switch-gray .custom-control-input:checked ~ .custom-control-label::after,
  .switch-gray .custom-control-input:checked ~ .custom-control-label::before {
    top: 0 !important;
  }
}
</style>
